import { useEffect, useState } from "react";
import { getPremiumReceivableTypeList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Premium Receivable transaction-type options sourced from
// /lookup/GetPIList/PremiumReceivableType. Label = PremiumReceivableTypeName,
// value = PremiumReceivableTypeCode.
//
// No Active filter and no SortOrder sort, unlike useTransactionTypeOptions:
// PremiumReceivableType_GetList already filters Active = 1, and SortOrder is
// NULL for every row, so DB order is all there is.
export function usePremiumReceivableTypeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getPremiumReceivableTypeList().then((rows) => {
      if (!mounted) return;
      setOptions(
        rows.map((r) => ({
          label: r.PremiumReceivableTypeName,
          value: r.PremiumReceivableTypeCode,
        }))
      );
    });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}

export default usePremiumReceivableTypeOptions;
